// Vendors
import 'src/scripts/vendor/jquery'
import 'src/scripts/vendor/bootstrap'
import jQuery from "jquery";
import ModulePreloader from "./modules/modulePreloader";
import Home from "./pages/home";
import ModuleNavigation from "./modules/moduleNavigation";
import Zunaechst from "./pages/zunaechst";
import Zugang from "./pages/zugang";
import Test from "./pages/test";

jQuery(document).ready(function () {
  let pageName = jQuery('body').data('page');

  const modulePreloader = new ModulePreloader();
  modulePreloader.init();

  const moduleNavigation = new ModuleNavigation()
  moduleNavigation.init();

  setTimeout(function () {

    if(pageName == "home") {
      const home = new Home();
      home.init();
    }
    else if(pageName == "zunaechst") {
      const zunaechst = new Zunaechst();
      zunaechst.init();
    }
    else if(pageName == "zugang") {
      const zugang = new Zugang();
      zugang.init();
    }
    else if(pageName == "test" || pageName == "test_kurz") {
      const test = new Test();
      test.init();
    }

  }, 500);
});
